import { staleChunkRecovery } from '../../allFeatures/AppVersion/staleChunkRecoveryInstance';

export async function lazyRoute<TPath extends string>(path: TPath) {
  try {
    // The template literal makes this a CONTEXT import: the bundler cannot know
    // which page is asked for, so it compiles every file under `src/pages` into
    // the build — test files included. That shipped 43 spec files (and their
    // comments) to every visitor, and a spec that imports `fs`/`path` for a
    // source-level assertion failed the production build outright. Excluding
    // them here is what keeps both true: specs may live beside the page they
    // describe, and none of them reach the browser.
    const data = await import(
      /* webpackExclude: /\.spec\.tsx?$/ */ `../../pages${path}`
    );
    staleChunkRecovery.onImportSuccess();
    return { Component: data.default };
  } catch (error) {
    if (staleChunkRecovery.onImportError(error)) {
      // A recovery reload is in progress — never resolve so the router
      // doesn't flash an error state while the page restarts.
      return new Promise<never>(() => {});
    }
    throw error;
  }
}
